import React, { useState, useEffect } from "react";
import {
  getDocs,
  getDoc,
  onSnapshot,
  doc,
  collection,
  updateDoc,
  setDoc,
  deleteDoc,
} from "firebase/firestore";
import { auth, db } from "../../firebase";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Industrynav from "./Industrynav";
function Displayapplied(prop) {
  // const [stu ,setStu]=useState("");
  const [indust, setindust] = useState([]);
  const [user, setUser] = useState();
  const location = useLocation();
  const { pos } = location.state;
  const ref = collection(
    db,
    `Industry/${auth.currentUser.uid}/Candidate/${pos}/applied`
  );

  useEffect(() => {
    const getjob = async () => {
      const data = await getDocs(ref);
      setindust(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };

    console.log(pos);
    getjob();
  }, []);

  // useEffect(() => {

  // },[])
  const applied = async (ide, posi, cid, postid, email,classes,departments) => {
    //
    let temp;
    await getDoc(doc(db, "selected", ide)).then((docSnap) => {
      if (docSnap.exists) {
        // setUser(docSnap.data());
        temp = docSnap.data();
        // ans=true;
      }
    });
    // console.log(temp.position)

    if (!temp) {
      await setDoc(doc(db, "selected", ide), {
        // position: [...user.position,{ cid:cid,stuid:ide,postid:postid }],
        position: [{ cid: cid, stuid: ide, postid: postid,class:classes,department:departments }],
      });
    } else {
      // let arr = [...temp.position,{ cid:cid,stuid:ide,postid:postid }];
      // let set = new Set(arr);
      // console.log(set);
      await setDoc(doc(db, "selected", ide), {
        position: [...temp.position, { cid: cid, stuid: ide, postid: postid,class:classes,department:departments }],
        // position: [{ cid:cid,stuid:ide,postid:postid }],
      });
    }

     updateDoc(doc(db,`appliedin/${ide}/applieds`, postid), {
     status:"Congratulation! You are Selected"
    });

    alert("Student Selected Successfully")
  };

  const deleteuser = async (email,ide,postid) => {
     await updateDoc(doc(db,`appliedin/${ide}/applieds`, postid), {
      status:"sorry! You are not selected. Better Luck next time"
     });
    const userDoc = doc(
      db,
      `Industry/${auth.currentUser.uid}/Candidate/${pos}/applied`,
      email
    );
    await deleteDoc(userDoc);
    window.location.reload(false);
    alert("candidate is rejected Successfully... time to find better");
  };
  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }
  return (
    <>
    <Industrynav/>
    
    <div className="mainn">
      <div className="recipes">
        {indust.map((post) => {
          return (
            <div className="recipe">
              <div className="preedit">
                <span className="postedit">Applied For : </span> {post.position}{" "}
              </div>
              {/* <ViewProfile uid={post.candidate}/> */}
              {/* <Check /> */}

              {/* { post.candidate? <ViewProfile uid={post.candidate}/>:"no hehehe"} */}
              <div className="preedit">
                <span className="postedit">Candidate Name : </span> {post.name}{" "}
              </div>
              <div className="preedit">
                <span className="postedit">Candidate email : </span>{" "}
                {post.email}{" "}
              </div>
              <div className="preedit">
                <span className="postedit">Candidate contact : </span>{" "}
                {post.contact}{" "}
              </div>
    
          
              <div className="buttons">
                <button
                  className="btn-secondary btn"
                  onClick={() => openInNewTab(`${post.resume}`)}
                >
                  View Resume
                </button>
                {/* <button
                  className="btn-warning"
                  onClick={() => window.open("/stuprofile", "_blank")}
                >
                  View Profile
                </button> */}
                 <Link className="btn-warning btn" to="/viewstudetails" state={{ stuid:post.candi }}>View Profle</Link>
              </div>

              <div className="buttons">
                <button
                  className="btn-success btn"
                  onClick={() =>
                    applied(
                      post.candi,
                      post.position,
                      post.cid,
                      post.postid,
                      post.email,
                      post.classes,
                      post.department
                    )
                  }
                >
                  Accepted
                </button>
                <button
                  className="btn-danger btn"
                  onClick={() => deleteuser(post.email,post.candi,post.postid)}
                >
                  Rejected
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
    </>
  );
}

export default Displayapplied;

